import { LOAN_REQUEST_CAR_FINANCING_WISHES, LOAN_REQUEST_CAR_TYPES, LOAN_REQUEST_USAGES } from 'cpool-constants';
import { z } from 'zod';

import { nullishDefault } from '../utils/nullableDefault';

export const Finanzbedarf = z.object({
    fahrzeugkauf: nullishDefault(
        z.object({
            anzahlung: nullishDefault(z.number()),
            fahrzeugPreis: nullishDefault(z.number()),
            fahrzeugTyp: nullishDefault(z.nativeEnum(LOAN_REQUEST_CAR_TYPES)),
            finanzierungswunsch: nullishDefault(z.nativeEnum(LOAN_REQUEST_CAR_FINANCING_WISHES)),
            schlussrate: nullishDefault(z.number()),
        }),
    ),
    finanzierungswunsch: z.object({
        kreditbetrag: nullishDefault(z.number()),
        laufzeitInMonaten: nullishDefault(z.number().int()),
    }),
    finanzierungszweck: nullishDefault(z.nativeEnum(LOAN_REQUEST_USAGES)),
});

// INFO old yup schema
//         finanzbedarf: yup.object().shape({
//             finanzierungswunsch: yup.object().shape({
//                 kreditbetrag: yup.number().optional().nullable().default(null),
//                 laufzeitInMonaten: yup.number().integer().optional().nullable().default(null),
//             }),
//             finanzierungszweck: yup
//                 .string()
//                 .oneOf(['UMSCHULDUNG', 'FAHRZEUGKAUF', 'MODERNISIEREN', 'FREIE_VERWENDUNG', null])
//                 .optional()
//                 .nullable()
//                 .default(null),
//         }),
